import type { InitOptions } from "i18next";

/**
 * Translations land after first paint (CDN namespace load, machine-translation
 * overlay `addResourceBundle`). react-i18next only re-renders on
 * `languageChanged` by default and ignores resource-store events entirely, so
 * any `t()` result captured before a bundle arrives stays stale until something
 * else re-renders the tree. That is invisible for callback-style consumers but
 * permanent for plain strings such as MUI's `paginationRowsPerPage`.
 *
 * Subscribe to store `added` so late bundle updates trigger re-renders. Omit
 * `removed` so preview shutdown does not flash English between
 * `removeResourceBundle` and `reloadResources`; failed reloads instead emit
 * `languageChanged` from the overlay restore path (see
 * `machine-translation-overlay.ts`). MT gap-fill still arrives asynchronously
 * after first paint, so missing keys may briefly show English until `added`.
 */
export const REACT_I18N_BINDINGS: InitOptions["react"] = {
  bindI18n: "languageChanged localeReady",
  bindI18nStore: "added",
};
